import {
  Routes,
  Route,
} from "react-router-dom";
import HomePage from "../screens/HomePage";

function PageRoutes(){
    return(
    <Routes>
      <Route path="/" element={<HomePage />} />
  </Routes>
    )
}
export default PageRoutes